<a [style.width.px]="compact() || menuItem() ? null : buttonWidth" [class.compact]="compact()" [class.menu-item]="menuItem()" href="#" (click)="onSmartButtonClick($event)" [title]="label()">
  <span class="label">
    @if (iconClass()) {
      <i [ngClass]="[iconClass()]" aria-hidden="true"></i>
    }
    <span class="label-text">{{ label() }}</span>
  </span>
  <i class="icon-next" aria-hidden="true"></i>
</a>
